var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ai-create-ques yxtbiz-intelligent-questioning",
      class: {
        "yxtbiz-ai-create-ques--left": _vm.editDisplay > 0,
        "yxtbiz-ai-create-ques--right": _vm.editDisplay < 0,
        "yxtbiz-ai-create-ques--ready": _vm.saveReady,
        "yxtbiz-ai-create-ques--saving": _vm.saving,
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-ai-create-ques__container" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-ai-create-ques__left-bar" },
          [
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  "open-delay": 300,
                  "hide-delay": 0,
                  content: _vm.$t(
                    "pc_biz_ote_btn_aicreatequestab" /** AI出题 */
                  ),
                  placement: "right",
                },
              },
              [
                _vm.aiEnable || _vm.createType === 1
                  ? _c(
                      "div",
                      {
                        class: {
                          actived: _vm.createType === 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeCreateType(1)
                          },
                        },
                      },
                      [
                        _c("yxt-svg", {
                          attrs: {
                            "remote-url": _vm.SvgMediaNewUrl,
                            width: "32px",
                            height: "32px",
                            "icon-class": "ai",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  "open-delay": 300,
                  "hide-delay": 0,
                  content: _vm.$t(
                    "pc_biz_ote_btn_quickcreatequestab" /** 快速建题 */
                  ),
                  placement: "right",
                },
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      actived: _vm.createType === 0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeCreateType(0)
                      },
                    },
                  },
                  [
                    _c("yxt-svg", {
                      attrs: {
                        "remote-url": _vm.SvgMediaNewUrl,
                        width: "32px",
                        height: "32px",
                        "icon-class": "ai-fast2",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { ref: "talkArea", staticClass: "yxtbiz-ai-create-ques__left" },
          [
            _c("ai-create-ques", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.createType === 1,
                  expression: "createType === 1",
                },
              ],
              ref: "aiCreator",
              attrs: { libId: _vm.libInfo.libId, libName: _vm.libInfo.libName },
              on: { addQues: _vm.addQuesList },
            }),
            _vm.createType === 0 || _vm.aiEnable
              ? _c("quick-create-ques", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.createType === 0,
                      expression: "createType === 0",
                    },
                  ],
                  ref: "quickCreator",
                  attrs: {
                    libId: _vm.libInfo.libId,
                    libName: _vm.libInfo.libName,
                  },
                  on: { addQues: _vm.addQuesList },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yxtbiz-ai-create-ques__right" },
          [
            !_vm.usedQuesList.length && !_vm.newQues
              ? _c("yxt-empty", { staticClass: "yxtbiz-ote-height-100" }, [
                  _c(
                    "div",
                    {
                      staticClass: "yxt-empty__text mh12",
                      attrs: { slot: "text" },
                      slot: "text",
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("pc_biz_ote_lbl_quesgeneratedtips2"))
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt12" },
                        [
                          _c(
                            "yxt-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.createNewQues },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-mid" },
                                [
                                  _c("yxt-svg", {
                                    staticClass: "mr4",
                                    attrs: {
                                      width: "16px",
                                      height: "16px",
                                      "icon-class": "common_plus",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_ote_btn_addques" /** 添加试题 */
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "yxtbiz-ote-height-100 flex flex-vertical" },
                  [
                    _vm.usedQuesList.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex-g-0 flex-shrink-0 flex flex-vertical flex-mid",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "yxtbiz-ai-create-ques__msgs",
                                class: _vm.isShowMsgError
                                  ? "yxtbiz-ai-create-ques__msgs--error"
                                  : "",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-between" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "shrink1 flex-g-1 flex flex-top",
                                      },
                                      [
                                        !_vm.isShowMsgError
                                          ? _c("yxt-svg", {
                                              staticClass: "mr8 mt4",
                                              attrs: {
                                                width: "14px",
                                                height: "14px",
                                                "icon-class": "message-success",
                                              },
                                            })
                                          : _vm._e(),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(_vm.checkTip),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm.isShowMsgError
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "shrink0 flex-g-0 pl8 flex flex-mid",
                                          },
                                          [
                                            _c(
                                              "yxt-tooltip",
                                              {
                                                attrs: {
                                                  content: _vm.$t(
                                                    "pc_biz_ote_btn_preverrorques"
                                                  ),
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("yxt-svg", {
                                                  staticClass:
                                                    "hand hover-bg-white border-radius-4",
                                                  attrs: {
                                                    width: "20px",
                                                    height: "20px",
                                                    "icon-class": "arrow_left",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.scrollToQues(
                                                        true,
                                                        -1
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "yxt-tooltip",
                                              {
                                                attrs: {
                                                  content: _vm.$t(
                                                    "pc_biz_ote_btn_nexterrorques"
                                                  ),
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("yxt-svg", {
                                                  staticClass:
                                                    "hand hover-bg-white ml8 border-radius-4",
                                                  attrs: {
                                                    width: "20px",
                                                    height: "20px",
                                                    "icon-class": "arrow_right",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.scrollToQues(
                                                        true,
                                                        1
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-g-1 shrink1 overflow-auto yxtbiz-ai-create-ques__right-ques-list",
                      },
                      [
                        _c(
                          "yxt-scrollbar",
                          { ref: "refQues", attrs: { "fit-height": true } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-ai-create-ques__right-ques-list-inner flex flex-vertical flex-mid flex-center",
                              },
                              [
                                _vm._l(
                                  _vm.usedQuesList,
                                  function (ques, index) {
                                    return _c("ques-simple-view-info", {
                                      key: ques._id,
                                      ref: "quesView",
                                      refInFor: true,
                                      attrs: {
                                        index: index + 1,
                                        quesBody: ques,
                                        otherEditing: _vm.editing,
                                        batching: _vm.batching,
                                        examId: _vm.examId,
                                      },
                                      on: {
                                        delete: function ($event) {
                                          return _vm.deleteQues(ques, index)
                                        },
                                        editStart: function ($event) {
                                          return _vm.editQuesStart(index)
                                        },
                                        editCancel: function ($event) {
                                          return _vm.editCancel(ques, index)
                                        },
                                        edit: function ($event) {
                                          return _vm.editQuesFinish(ques, index)
                                        },
                                        check: _vm.handleCheckedQuesChange,
                                      },
                                    })
                                  }
                                ),
                                _vm.newQues
                                  ? _c("ques-simple-view-info", {
                                      ref: "quesViewNew",
                                      attrs: {
                                        create: "",
                                        index: _vm.usedQuesList.length + 1,
                                        quesBody: _vm.newQues,
                                        otherEditing: false,
                                        libId: _vm.libInfo.libId,
                                        libName: _vm.libInfo.libName,
                                        examId: _vm.examId,
                                      },
                                      on: {
                                        editCancel: _vm.cancelSaveNewQues,
                                        edit: _vm.saveNewQues,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.usedQuesList.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "yxtbiz-ai-create-ques__right-batch-options",
                          },
                          [
                            !_vm.batching
                              ? [
                                  _c(
                                    "yxt-button",
                                    {
                                      staticClass: "color-gray-9 mr20",
                                      attrs: { type: "text2" },
                                      on: { click: _vm.createNewQues },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex flex-mid" },
                                        [
                                          _c("yxt-svg", {
                                            staticClass: "mr4",
                                            attrs: {
                                              width: "16px",
                                              height: "16px",
                                              "icon-class": "common_plus",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_btn_addques" /** 添加试题 */
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "yxt-button",
                                    {
                                      staticClass: "color-gray-9",
                                      attrs: { type: "text2" },
                                      on: {
                                        click: function ($event) {
                                          _vm.batching = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex flex-mid" },
                                        [
                                          _c("yxt-svg", {
                                            staticClass: "mr4",
                                            attrs: {
                                              width: "16px",
                                              height: "16px",
                                              "remote-url": _vm.SvgMediaNewUrl,
                                              "icon-class": "ai-batch",
                                            },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_btn_batchdo" /** 批量操作 */
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "yxt-checkbox",
                                    {
                                      attrs: {
                                        indeterminate: _vm.isIndeterminate,
                                      },
                                      on: { change: _vm.handleCheckAllChange },
                                      model: {
                                        value: _vm.checkedAll,
                                        callback: function ($$v) {
                                          _vm.checkedAll = $$v
                                        },
                                        expression: "checkedAll",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "h5_biz_ote_btn_selectall"
                                          ) /** 全选 */
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-g-1 flex-right flex-mid",
                                    },
                                    [
                                      _c(
                                        "yxt-button",
                                        {
                                          staticClass: "color-gray-9 mr20",
                                          attrs: { type: "text2" },
                                          on: { click: _vm.batchChangeLib },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-mid" },
                                            [
                                              _c("yxt-svg", {
                                                staticClass: "mr4",
                                                attrs: {
                                                  width: "16px",
                                                  height: "16px",
                                                  "remote-url":
                                                    _vm.SvgMediaNewUrl,
                                                  "icon-class": "ai-lib",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pc_biz_ote_btn_changelib" /** 换库 */
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "yxt-button",
                                        {
                                          staticClass: "color-gray-9 mr16",
                                          attrs: { type: "text2" },
                                          on: { click: _vm.batchDeleteQues },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-mid" },
                                            [
                                              _c("yxt-svg", {
                                                staticClass: "mr4",
                                                attrs: {
                                                  width: "16px",
                                                  height: "16px",
                                                  "icon-class": "delete",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pc_biz_ote_btn_delete" /** 删除 */
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c("yxt-divider", {
                                        attrs: { direction: "vertical" },
                                      }),
                                      _c(
                                        "yxt-button",
                                        {
                                          staticClass: "mr24",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              _vm.batching = false
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex flex-mid" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "pc_biz_quit" /** 退出 */
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "yxt-drawer",
                      {
                        staticClass: "yxtbiz-lib-selector__select-drawer",
                        attrs: {
                          title: _vm.$t("pc_biz_ote_msg_selqueslib"),
                          visible:
                            _vm.selectLibDrawerData.isShowSelectLibDrawer,
                          size: "960px",
                          "destroy-on-close": true,
                          "before-close": function (done) {
                            return done(
                              _vm.$refs.selectLib &&
                                _vm.$refs.selectLib.dialogEdited
                            )
                          },
                        },
                        on: {
                          "update:visible": function ($event) {
                            return _vm.$set(
                              _vm.selectLibDrawerData,
                              "isShowSelectLibDrawer",
                              $event
                            )
                          },
                        },
                      },
                      [
                        _c("yxtbiz-lib-selector", {
                          ref: "selectLib",
                          attrs: {
                            needCreateLib: "",
                            createType: _vm.examId ? 1 : 0,
                            states: _vm.selectLibDrawerData,
                          },
                          on: {
                            selectLibCallback: _vm.selectLibCallback,
                            closeSelectLibDrawer: _vm.closeSelectLibDrawer,
                          },
                        }),
                        _c(
                          "div",
                          { attrs: { slot: "footer" }, slot: "footer" },
                          [
                            _c(
                              "yxt-button",
                              {
                                attrs: { plain: "" },
                                on: { click: _vm.selectLibClose },
                              },
                              [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
                            ),
                            _c(
                              "yxt-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.selectLibSubmit },
                              },
                              [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
        _c("div", { staticClass: "yxtbiz-ai-create-ques__bar" }, [
          _c(
            "div",
            [
              _vm.editDisplay <= -1
                ? _c(
                    "yxt-tooltip",
                    {
                      key: "btnr_" + _vm.editDisplay,
                      attrs: {
                        "open-delay": 500,
                        "hide-delay": 0,
                        content: _vm.$t(
                          _vm.editDisplay < 0
                            ? "pc_biz_ote_btn_aieditfullexit"
                            : "pc_biz_ote_btn_aitalkfull"
                        ),
                        placement: _vm.editDisplay < 0 ? "right" : "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabEdit(1)
                            },
                          },
                        },
                        [
                          _c("yxt-svg", {
                            staticClass: "hand",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "arrow_right",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.editDisplay >= 0
                ? _c(
                    "yxt-tooltip",
                    {
                      key: "btnl_" + _vm.editDisplay,
                      attrs: {
                        "open-delay": 500,
                        "hide-delay": 0,
                        content: _vm.$t(
                          _vm.editDisplay > 0
                            ? "pc_biz_ote_btn_aitalkfullexit"
                            : "pc_biz_ote_btn_aieditfull"
                        ),
                        placement: _vm.editDisplay > 0 ? "left" : "top",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.tabEdit(-1)
                            },
                          },
                        },
                        [
                          _c("yxt-svg", {
                            staticClass: "hand",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              "icon-class": "arrow_left",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }